module.exports = __webpack_public_path__ + "assets/img/Workspace-min.32f86c01.png";